import { createGlobalStyle } from 'styled-components';
import { t } from 'theme';

/**
 * Page-level theme. Publishes the palette as CSS custom properties so the plain CSS in
 * index.css (the map SVG, in particular) can follow the theme without being ported to
 * styled-components.
 *
 * **Nothing here transitions, and nothing that transitions may live here.** styled-components
 * replaces this sheet's rules wholesale whenever an interpolation changes, and for one frame
 * the rule is gone — every declaration in it reverts to the property's initial value, and the
 * browser takes that as the starting point of any transition on it. That is how the page
 * background came to start each crossover at `transparent`, and a transparent page is a white
 * one. See Page.style.js, which is where the moving parts went.
 *
 * Custom properties are exempt: a value that only ever snaps is fine, and index.css has no
 * other way to reach the palette.
 */
const GlobalTheme = createGlobalStyle`
  :root {
    --bg: ${t('bg')};
    --fg: ${t('fg')};
    --muted: ${t('muted')};
    --rule: ${t('rule')};
    --panel: ${t('panel')};
    --map-filter: ${t('mapFilter')};
  }

  /* The colour is on the Backdrop, which is a real element and can therefore hold a fade.
     These stay out of the way of it. */
  html,
  body {
    background-color: transparent;
  }
`;

export default GlobalTheme;
